// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H22V9H2V2ZM4 11L4 20L20 20V11H22V22L2 22L2 11H4ZM6 12L18 12V14L6 14V12ZM6 16H18V18H6V16Z"}}]};

const ComponentDropdownFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-dropdown-filled',
    ref,
    icon: element,
  },
));

ComponentDropdownFilledIcon.displayName = 'ComponentDropdownFilledIcon';

export default ComponentDropdownFilledIcon;
